"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Super/SuperTeamMembers.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _SuperTableTR = require('web/components/Super/SuperTableTR'); var _SuperTableTR2 = _interopRequireDefault(_SuperTableTR);






const SuperTeamMembers = ({ members }) => {
  const rows = Object.values(members).map((m) => {
    return (
      _react2.default.createElement(_SuperTableTR2.default, { key: m.UserKey, to: `/super/users/${m.UserKey}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}}
        , _react2.default.createElement('td', { className: "uuid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}, m.UserKey)
        , _react2.default.createElement('td', { className: "bool", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}, m.Inboxable ? 'yes' : 'no')
        , _react2.default.createElement('td', { className: "bool", __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}, m.OverrideNotificationSettings ? 'yes' : 'no')
        , _react2.default.createElement('td', { className: "bool", __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}, m.VipNotifications ? 'yes' : 'no')
        , _react2.default.createElement('td', { className: "bool", __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}, m.MuteForever ? 'yes' : 'no')
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}, m.MuteUntil)
        , _react2.default.createElement('td', { className: "bool", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}, m.Removed ? 'yes' : 'no')
      )
    )
  })

  return (
    _react2.default.createElement('table', { className: "super--table", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}
      , _react2.default.createElement('thead', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}
        , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
          , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}, "User Key" )
          , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}, "Inboxable")
          , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}, "Override Notifications" )
          , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}, "VIP Notifications" )
          , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}, "Mute Forever" )
          , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}, "Mute Until" )
          , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}, "Removed")
        )
      )
      , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
        , rows
      )
    )
  )
}

exports. default = SuperTeamMembers
